// Func = limiting Scope for this file
var lastScrollTop = 0;
let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
(function () {
  $(document).ready(function () {
    //Call function with browser is resized.
    // $(window).resize(function (event) {
    //   resizeWindow();
    // });
    // resizeWindow();

    if (isMobile) {
      const amenities = document.getElementById("home").getElementsByClassName("amenities-block")[0];
      //console.log(amenities);
      $('.sym-inline-list').slick({
        accessibility: false
    });
    }

    // Primary nav animation
    if(document.getElementById('primary-nav')){
      const mainNav = document.getElementById('mainNavBg');
      document.getElementById('primary-nav').querySelectorAll('a').forEach(link => {
        let newClass = '';
        link.addEventListener('mouseenter', function(){
          newClass = this.innerHTML.toLowerCase().replace(' ', '-');
          mainNav.classList.add(newClass)
        })
        link.addEventListener('mouseleave', function(){
          newClass = this.innerHTML.toLowerCase().replace(' ', '-');
          mainNav.classList.remove(newClass)
        })
        
        if(link.classList.contains('active') && !link.parentElement.parentElement.classList.contains('submenu')){
          let activeClass = link.innerHTML.toLowerCase().replace(' ', '-');
          mainNav.classList.add(activeClass)
        }
      });

    }
    



    
    
    // Main Nav Dropdown
    $("#primary-nav li").hover(
      function () {
        $(this).addClass("hover");
        $("ul.submenu", this).fadeIn(200);
      },
      function () {
        $(this).removeClass("hover");
        $("ul.submenu", this).fadeOut(200);
      }
    );

    //Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
    let DATE_STYLE = [true];
    function calendarRange(date) {
      let d1 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckIn").val());
      let d2 = $.datepicker.parseDate(DATE_FORMAT, $("#CheckOut").val());
      if (
        (d1 && date.getTime() == d1.getTime()) ||
        (d2 && date.getTime() == d2.getTime())
      ) {
        DATE_STYLE[1] = "highlight-top";
      } else if (date > d1 && date < d2) {
        DATE_STYLE[1] = "highlight";
      } else {
        DATE_STYLE[1] = "";
      }
      return DATE_STYLE;
    }

    //Check in and check out datepicker for booking engine
    const DATE_FORMAT =
      $("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")
        ? $("#CheckIn").data("format")
        : "yy-mm-dd";
    $("#CheckIn").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      changeMonth: true,
      dateFormat: DATE_FORMAT,
      numberOfMonths: 1,
      minDate: 0,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        let getDate = $(this).datepicker("getDate");
        let newDate = new Date(getDate.getTime());
        newDate.setDate(newDate.getDate() + 3);
        $("#CheckOut").datepicker("setDate", newDate);
        $("#CheckOut").datepicker("option", "minDate", selectedDate);
      },
    });
    $("#CheckOut").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      dateFormat: DATE_FORMAT,
      changeMonth: true,
      numberOfMonths: 1,
      beforeShowDay: (date) => calendarRange(date),
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
      },
    });

    // Map: Return to previous page button. Change body id to match map template's name.
    //$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
  });

  window.onload = function () {
    /*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

      //Open Navigation
      $('#menu-btn').click(function(event) {
				$('html').addClass('hide-overflow');
				$('.nav-desktop').addClass('open');
				$('.nav-desktop').stop().animate({left:'0px'},{duration:300});
				if($('.nav-desktop ul li a').hasClass('.item-open')){
					$(".item-open").get(0).scrollIntoView(false);
				}
			});

			$('.close-menu').click(function(event) {
				event.preventDefault();
				$('html').removeClass('hide-overflow');
				$('.nav-desktop').removeClass('open');
				$('.nav-desktop').stop().animate({left:'-100%'},{queue:false,duration:300});
			});
      

    // scrollDownAction(20, 'scroll');

    scrollW();
    window.addEventListener("scroll", function () {
      scrollW();
    });
  };

  if (screen.width < 640) {
    //---------------Section marriot finePrint-------------------
    //Section capture navbarPrint and find all childNodes
    let captureItem = document.querySelectorAll(".marriott-fineprint")[0]
      .childNodes;

    //compare every nodeType with the value text and remove the item
    captureItem.forEach((item) => {
      item.nodeType == 3 ? item.remove() : "";
    });
    //---------------END Section marriot finePrint-------------------
  }
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
